import { Button } from '@/components/ui/Button';
import styles from '../SessionRestorePrompt/SessionRestorePrompt.module.css';

interface Props {
  onTakeOver(): void;
}

/** Nicht schließbarer Hinweis, wenn ein anderer Tab dieselbe Session hält
 *  (Web Lock, Audit M8a). „Continue here" übernimmt den Lock — der andere
 *  Tab bekommt dann diesen Hinweis. Gleiche Modal-Chrome-Familie wie
 *  SessionRestorePrompt (geteiltes Stylesheet). */
export function SessionLockedPrompt({ onTakeOver }: Props) {
  return (
    <div className={styles.backdrop} role="dialog" aria-modal="true">
      <div className={styles.panel}>
        <h2 className={styles.title}>Open in Another Tab</h2>
        <p className={styles.body}>
          This project is already open in another browser tab or window. To
          avoid losing work, only one tab can edit at a time.
          Close the other tab, or continue here — the other tab will then be
          paused.
        </p>
        <div className={styles.actions}>
          <Button variant="primary" size="sm" onClick={onTakeOver}>
            <i className="ph-bold ph-browsers" aria-hidden="true" />
            Continue Here
          </Button>
        </div>
      </div>
    </div>
  );
}
